import { useRef } from 'react';
import { logEventString, type TDict } from '@adv-frontend/yastore-modules/logger';

/**
 * Оборачивает обработчик `onChange` поля: логирует первый ввод в поле,
 * после чего вызывает исходный обработчик. Дальнейшие вводы в то же поле не логируются.
 *
 * @kind helper
 * @param event - имя события
 * @param meta - доп. поля события
 * @returns Функцию-обёртку `(field, onChange?) => handler`
 */
export const useLogFieldInputOnce = (event: string, meta?: TDict) => {
    const loggedInputsRef = useRef<Record<string, boolean>>({});

    function withLogging<TArgs extends unknown[]>(field: string, onChange?: (...args: TArgs) => void) {
        return (...args: TArgs) => {
            if (!loggedInputsRef.current[field]) {
                loggedInputsRef.current[field] = true;
                logEventString(event, field, meta);
            }

            onChange?.(...args);
        };
    }

    return withLogging;
};
